import { render } from "./querystatusreport.vue?vue&type=template&id=045675bb"
import script from "./querystatusreport.js?vue&type=script&lang=js"
export * from "./querystatusreport.js?vue&type=script&lang=js"

import "./querystatusreport.vue?vue&type=style&index=0&id=045675bb&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__